import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=6202f365&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6202f365')) {
      api.createRecord('6202f365', component.options)
    } else {
      api.reload('6202f365', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=6202f365&", function () {
      api.rerender('6202f365', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IzYD95TKRnpX/JS/cancellationPolicy.vue"
export default component.exports